import { computed, effect, inject, Signal } from '@angular/core';
import { FieldComponent } from './field';

let nextId = 0;

/**
 * Resolves a unique DOM id for a form control and links it to the enclosing <app-field> label.
 * Priority: explicit id on the control → the field's `for` → a generated unique id.
 * Must be called in an injection context (a field initializer of the control component).
 */
export function fieldControlId(explicitId: () => string | undefined): Signal<string> {
  const field = inject(FieldComponent, { optional: true });
  const generated = `fss-ctrl-${++nextId}`;
  const id = computed(() => explicitId() || field?.for() || generated);

  if (field) {
    effect(() => field.registerControlId(id()));
  }

  return id;
}
